import type { ReactNode } from "react";
import { CommentHeader, CommentLayout, Comments } from "../../Comments/Comments";
import useComment from "../../Comments/useComment";
import { QuestionContent, QuestionHeader, QuestionResponse, ResponseLayout } from "../../Layouts";
import AverageScore from "./AverageScore";
import RatingChart from "./RatingChart";

function RatingCommentCompact() {
    const { answer } = useComment();
    return (
        <RatingComment>
            <div className="font-light italic max-h-6 flex items-start max-w-full pr-12">
                <span>&quot;</span>
                <p className="truncate">{answer.comment?.answerComment}</p>
                <span>&quot;</span>
            </div>
        </RatingComment>
    );
}

function RatingCommentFull() {
    const { answer } = useComment();
    return (
        <div className="border-b border-container-outline w-full pb-4 group-last:border-0">
            <RatingComment>
                <div className="font-light italic flex items-start max-w-full pr-12 whitespace-pre-wrap">
                    <p>&quot;{answer.comment?.answerComment}&quot;</p>
                </div>
            </RatingComment>
        </div>
    );
}

function RatingComment({ children }: { children?: ReactNode }) {
    const { answer } = useComment();

    return (
        <div className="max-w-full w-full flex items-center gap-2">
            <div className="bg-secondary/70 min-w-10 h-10 rounded-full flex items-center justify-center font-medium">
                {answer.answerValue}
            </div>
            {children}
        </div>
    );
}

export default function RatingResponse() {
    return (
        <ResponseLayout>
            <QuestionResponse>
                <QuestionHeader />
                <QuestionContent>
                    <div className="flex w-full min-w-0 flex-col items-center gap-4 sm:flex-row sm:gap-0">
                        <RatingChart />
                        <AverageScore />
                    </div>
                </QuestionContent>
            </QuestionResponse>
            <CommentLayout>
                <CommentHeader>
                    <RatingCommentFull />
                </CommentHeader>
                <Comments>
                    <RatingCommentCompact />
                </Comments>
            </CommentLayout>
        </ResponseLayout>
    );
}
